import { ColumnDef } from "@tanstack/react-table";
import { User } from "@/endpoints/dryp/user";
import { ActionsMenuColumn } from "@/components/tableColumns/ActionsMenuColumn";
import { USER_BASE_COLUMNS } from "@/components/Users";
import { useMemo } from "react";
import { useStore } from "@/hooks/useStore";

export function useUserColumns(refreshUsers: () => void): ColumnDef<User>[] {
	const {
		uiStore: { modalStore },
		userStore,
	} = useStore();

	const canManageUsers = userStore.isAdmin || userStore.isSuperAdmin;

	return useMemo(
		() => [
			...USER_BASE_COLUMNS,
			...(canManageUsers
				? [
						ActionsMenuColumn<User>({
							actions: [
								{
									label: "Edit",
									onSelect: row => {
										modalStore.open("editUser", {
											user: row.original,
											onSuccess: refreshUsers,
										});
									},
								},
								// {
								// 	label: "Remove",
								// 	destructive: true,
								// 	onSelect: row => {
								// 		console.log("Removing user", row.original.id);
								// 	},
								// },
							],
							header: "",
							className: "w-10",
						}),
					]
				: []),
		],
		[canManageUsers],
	);
}
